import { Injectable } from '@angular/core';
import { PreferencesService } from '../../api/services/preferences.service';
import { FileUploadService } from '../../api/services/file-upload.service';
import { of } from 'rxjs/observable/of';

@Injectable()
export class AvatarService {

  constructor(private preferencesService: PreferencesService,
    private fileUploadService: FileUploadService) { }

  getAvatarByUserId(userId: string) {
    return this.preferencesService.getPreferences('USER', userId)
    .switchMap((prefs) => {
      const logoId = prefs['profile-logo'].Value;

      return logoId? this.getAvatarByFileId(logoId) : of('');
    });
  }

  getAvatarByOrgId(orgId: string) {
    return this.preferencesService.getPreferences('CUSTOMER', orgId)
    .switchMap((prefs) => {
      const logoId = prefs['organization-logo'].Value;

      return logoId? this.getAvatarByFileId(logoId) : of('');
    });
  }

  getAvatarByFileId(fileId: string) {
    return this.fileUploadService.get(fileId)
    .map(image => image.url);
  }

  saveAvatar(userId: string, fileId: string) {
    return this.preferencesService
    .setPreference('USER', userId, 'profile-logo', {Value: fileId});
  }

  removeAvatar(userId: string) {
    return this.preferencesService.deletePreference('USER', userId, 'profile-logo');
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/services/avatar.service.ts